import React from 'react'
import {NavLink} from 'react-router-dom'

import Icon, {Icons} from '../../icons/Icon'

export interface SidebarNavItemProps {
  to: string;
  title: string;
  icon: Icons;
}

export const MenuNavItem = ({to, title, icon}: SidebarNavItemProps) => {
  return (
    <NavLink
      to={to}
      className={({isActive}) =>
        `flex justify-start items-center gap-4 w-full px-8 py-4 lg:p-4 lg:rounded-lg group ${isActive ?
          'bg-kwota-primary-500 text-kwota-neutral-100 font-semibold cursor-default' : 'hover:bg-kwota-primary-100 font-normal'}`
      }
    >
      {({isActive}) =>
        <>
          <Icon
            icon={icon}
            className={`w-6 h-6 flex justify-center items-center ${
              isActive ? 'fill-kwota-neutral-100' : 'fill-kwota-neutral-800'
            }`}
          />
          <p
            className={`text-lg ${isActive ?
              'text-kwota-neutral-100' : 'text-kwota-neutral-800'}`}
          >
            {title}
          </p>
        </>
      }
    </NavLink>
  )
}
